import {Component, Input, ViewEncapsulation} from '@angular/core';
import {AbstractControlDirective, AbstractControl} from '@angular/forms';

@Component({
  selector: 'app-form-error',
  templateUrl: './form-validation.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./form-validation.component.scss']
})
export class FormValidationComponent {

  private static readonly errorMessages = {
    'required': () => 'This field is required',
    'pattern': () => 'Invalid input',
    'appEmail': (params) => params.message,
    'appPhoneNumber': (params) => params.message,
  };

  @Input() private control: AbstractControlDirective | AbstractControl;
  @Input() private error: string;

  shouldShowErrors(): boolean {
    return this.control && this.control.errors && this.control.touched;
  }

  listOfErrors(): string[] {
    return Object.keys(this.control.errors)
      .map(field => this.getMessage(field, this.control.errors[field]));
  }

  private getMessage(type: string, params: any) {
    if (!type || !params) {
      return '';
    }
    const error = FormValidationComponent.errorMessages[type];
    if (!error || typeof error !== 'function') {
      return '';
    }
    return error(params);
  }

}
